<ic-skeleton-region id="ic-alerts-tb-container" [busy]="isLoading()">
	<img id="ic-sys-alert" ngSrc="assets/img/sys_alerts.png" width="29" height="28" loading="eager" alt="" class="prevent-select">
	<div class="ic-w-alert" [pTooltip]="'TOOLTIPS.ALARMS' | translate" tooltipPosition="bottom" appendTo="body">
		<img ngSrc="assets/img/sys_alarms.png" width="33" height="32" loading="eager" alt="" class="prevent-select">
		<span class="prevent-select">@if (isLoading()) {<ic-skeleton width="2ch" tone="inverse" />} @else {<ng-container>{{ alarmsCount() }}</ng-container>}</span>
	</div>
	<div class="ic-w-alert" [pTooltip]="'TOOLTIPS.ET_FAILURES' | translate" tooltipPosition="bottom" appendTo="body">
		<img ngSrc="assets/img/sys_et_failures.png" width="33" height="32" loading="eager" alt="" class="prevent-select">
		<span class="prevent-select">@if (isLoading()) {<ic-skeleton width="2ch" tone="inverse" />} @else {<ng-container>{{ etFailureCount() }}</ng-container>}</span>
	</div>
	<div class="ic-w-alert ic-w-alert--clickable" role="button" tabindex="0"
		[pTooltip]="'TOOLTIPS.OUT_OF_SYNC' | translate" tooltipPosition="bottom" appendTo="body"
		(click)="goToOutOfSync()" (keydown.enter)="goToOutOfSync()">
		<img ngSrc="assets/img/sys_out_of_sync.png" width="33" height="32" loading="eager" alt="" class="prevent-select">
		<span class="prevent-select">@if (isLoading()) {<ic-skeleton width="2ch" tone="inverse" />} @else {<ng-container>{{ outOfSyncCount() }}</ng-container>}</span>
	</div>
</ic-skeleton-region>
